var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NcIconSvgWrapper',{staticClass:"recently-created-marker-icon",attrs:{"name":_vm.t('files', 'Recently created'),"path":_vm.mdiPlus}})
}
var staticRenderFns = []

export { render, staticRenderFns }